import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import "../Messaggi/OverPanel.css";
import appLib from "../../../libs/appLib.mjs";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import UserIcon from "../../../media/assets/UserIcon.mjs";
import "./UserDetails.css";
import AppDislikeIcon from "../../../media/assets/AppDislikeIcon.mjs";
import AppBachecaIcon from "../../../media/assets/AppBachecaIcon.mjs";
import AppLikedIcon from "../../../media/assets/AppLikedIcon.mjs";
import SettingsIcon from "../../../media/assets/SettingsIcon.mjs";
import {Button, ButtonGroup} from "reactstrap";
import AppNoDislikeIcon from "../../../media/assets/AppNoDislikeIcon.mjs";
import TrashIcon from "../../../media/assets/TrashIcon.mjs";
import AppAboutIcon from "../../../media/assets/AppAboutIcon.mjs";

const prefix = "UserDetails";

const UserDetails = class extends Component {
	constructor(props) {
		super(props);
		this.state = { cu: appLib.currentUser() };
		this.uid = Glob.generateUid(prefix);
		this.close = this.close.bind(this);
		this.load = this.load.bind(this);
		this.change = this.change.bind(this);
		this.icon = this.icon.bind(this);
	}
	componentDidMount() {
		Glob.register('EscapeKeyWasPressed', this.close, this.uid);
		this.load();
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	load() {
		const uid = this.props.user?.id ?? this.props.data?.id ?? this.props.user;
		this.setState({saving: true}, ()=>{
			appLib.api('admin/user-details', {user: uid }).then( data => {
				data.loaded = true;
				this.setState(data);
			}).catch(error => {
				console.log(error);
				this.close();
			}).finally(()=>{
				this.setState({saving: false});
			})
		});
	}
	close() {
		Glob.trigger(prefix);
	}
	change( mode ) {
		mode.id = this.state.user?.id;
		this.setState({ saving: true }, ()=>{
			appLib.api('admin/user-change', { user: mode } ).then( () => {
				Glob.trigger('UsersChanged',true);
				this.load();
			}).catch( error => {
				console.log(error);
			}).finally( ()=>{
				this.setState({saving: false});
			})
		});
	}
	icon() {
		if (this.state.user?.moderator || this.state.user?.admin) return <SettingsIcon />;
		if ( this.state.user?.disabled) return <AppDislikeIcon fill={"#c00"} />;
		if ( this.state.user?.deleted) return <TrashIcon fill={"#900"} />;
		return <AppAboutIcon />;
	}
	render() {
		if ( ! this.state.loaded ) return null;
		return (
			<div
				className={"OverPanel "+prefix+( this.state.saving ? " busy" : "" )}
				onClick={ this.close }
				onScroll={ e => {
					e.preventDefault();
					e.stopPropagation();
				}}
			>
				<div
					onClick={ e => {
						e.preventDefault();
						e.stopPropagation();
					}}
				>
					<div>
						<h2>
							{ this.icon() }
							<span>{ this.state.user?.name }</span>
							<span className={"closer"} onClick={ this.close }>
								<CloseIcon />
							</span>
						</h2>
						<table>
							<tbody>
							<tr>
								<td colSpan={2}>
									<UserIcon />
									<span>Utente</span>
								</td>
							</tr>
							<tr>
								<td>ID</td>
								<td>
									<strong>{ this.state.user?.id }</strong>
								</td>
							</tr>
							<tr>
								<td>Username</td>
								<td>{ this.state.user?.name }</td>
							</tr>
							<tr>
								<td>Email</td>
								<td><a href={"mailto:"+this.state.user?.email}>{ this.state.user?.email }</a></td>
							</tr>
							<tr>
								<td>Ultima attività</td>
								<td>{ (new Date(this.state.user?.last_update)).toLocaleString(Glob.getLanguageLong()) }</td>
							</tr>
							<tr>
								<td colSpan={2}>
									<AppBachecaIcon />
									<span>Annunci</span>
								</td>
							</tr>
							<tr>
								<td>Totali</td>
								<td><strong>{ this.state.msg?.tot}</strong></td>
							</tr>
							<tr>
								<td>Moderati</td>
								<td><strong>{ this.state.msg?.expired}</strong></td>
							</tr>
							<tr>
								<td>Eliminati</td>
								<td><strong>{ this.state.msg?.deleted}</strong></td>
							</tr>
							<tr>
								<td>Scaduti</td>
								<td><strong>{ this.state.msg?.expired}</strong></td>
							</tr>
							<tr>
								<td colSpan={2}>
									<AppDislikeIcon />
									<span>Segnalazioni</span>
								</td>
							</tr>
							<tr>
								<td>Inviate</td>
								<td>
									<strong>{ this.state.report?.sent }</strong>
								</td>
							</tr>
							<tr>
								<td>Ignorate</td>
								<td>
									<strong>{ this.state.report?.ignored }</strong>
								</td>
							</tr>
							<tr>
								<td>Ricevute</td>
								<td>
									<strong>{ this.state.report?.received }</strong>
								</td>
							</tr>
							<tr>
								<td colSpan={2}>
									<AppLikedIcon />
									<span>Like</span>
								</td>
							</tr>
							<tr>
								<td>Inviati</td>
								<td>
									<strong>{ this.state.likes?.sent }</strong>
								</td>
							</tr>
							<tr>
								<td>Ricevuti</td>
								<td>
									<strong>{ this.state.likes?.received }</strong>
								</td>
							</tr>
							</tbody>
						</table>
						<div className={"actions"}>
							<hr />
							<ButtonGroup
								vertical={true}
								className={"btn-icon"}
							>
								{ (this.state.cu?.admin && ! (this.state.user?.admin || this.state.user?.deleted || this.state.user?.disabled) ) && (
									this.state.user?.moderator ? (
										<Button
											color="warning"
											onClick={ ()=>{ this.change({ moderator:false}) }}
										>
											<b>
												Togli la moderazione
											</b>
											<i>
												<UserIcon />
											</i>
										</Button>
									) : (
										<Button
											color="success"
											onClick={ ()=>{ this.change({ moderator:true}) }}
										>
											<b>
												Rendi moderatore
											</b>
											<i>
												<SettingsIcon />
											</i>
										</Button>
									)
								)}
								{ !(this.state.user?.admin || this.state.user?.moderator) && (
									this.state.user?.disabled ? (
										<Button
											color="primary"
											onClick={ ()=>{ this.change({ disabled:false}) }}
										>
											<b>
												Ri-abilita l’utente
											</b>
											<i>
												<AppNoDislikeIcon />
											</i>
										</Button>
									) : (
										<Button
											color="danger"
											onClick={ ()=>{ this.change({ disabled:true}) }}
										>
											<b>
												Disabilita l’utente
											</b>
											<i>
												<AppDislikeIcon />
											</i>
										</Button>
									)
								)}
							</ButtonGroup>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default UserDetails;